import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/order-batch"

class service {

    getFlowByBatchId(id) {
        return http.list(path + "/flow/" + id)
    }
}

export default new service();


